// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-o_fS","advertDetailService__price":"c-o_fT"};